import type { DrawinkFontFaceDescriptor } from "../Fonts";

import _1 from "./094cf798c7853874faa9834753ff974d.woff2";
import _5 from "./5d76f2b26cbe38a8a6370486b3a093eb.woff2";
import _3 from "./9db90087c58af3004505e9e6bd64296c.woff2";
import _4 from "./585b179940e3936ef2457e284ac705d5.woff2";
import _2 from "./adcc33d6f9dab04337b67be84581cd1b.woff2";
import _0 from "./c91ab54ceeec20f762023fcd5f679931.woff2";

/* Generated By cn-font-split@5.2.2 https://www.npmjs.com/package/cn-font-split
CreateTime: Wed, 10 Dec 2025 19:21:25 GMT;
Origin File Name Table:
copyright: Copyright (c) 2011 by Your Own Font Foundry. All rights reserved.
fontFamily: Virgil 3 YOFF
fontSubfamily: Regular
uniqueID: Version 001.001;YOFF;Virgil3YOFF;2020;FL720
fullName: Virgil3YOFF
version: Version 001.001
postScriptName: Virgil3YOFF
trademark: Virgil YOFF is a trademark of Your Own Font Foundry.
manufacturer: Your Own Font Foundry
designer: Your Own Font Foundry
license: Freeware for personal use! For commercial license please go to https://www.yourownfont.com/
 */

export const VirgilFontFaces: DrawinkFontFaceDescriptor[] = [
  {
    uri: _0,
    descriptors: {
      unicodeRange:
        "U+d,U+20-7e,U+a1-a3,U+a5-a6,U+a8-ab,U+ad-b5,U+b7-ff,U+131,U+152-153,U+2c6,U+2da,U+2dc,U+2013-2014,U+2018-201a,U+201c-201e,U+2022,U+2024-2026,U+2030,U+2039-203a,U+20ac,U+2122,U+2212",
    },
  },
  {
    uri: _1,
    descriptors: {
      unicodeRange:
        "U+100-130,U+132-137,U+139-149,U+14c-151,U+154-17e,U+1fc-1ff,U+218-21b,U+237,U+1e80-1e85,U+1ef2-1ef3",
    },
  },
  {
    uri: _2,
    descriptors: {
      unicodeRange: "U+384-386,U+388-38a,U+38c,U+38e-393,U+395-3a1,U+3a3-3a8,U+3aa-3ce",
    },
  },
  {
    uri: _3,
    descriptors: {
      unicodeRange: "U+2c7,U+2d8-2d9,U+2db,U+2dd,U+2126,U+2206,U+2211,U+f6c3",
    },
  },
  {
    uri: _4,
    descriptors: {
      unicodeRange: "U+462,U+4d8-4d9,U+4e6-4e7",
    },
  },
  {
    uri: _5,
    descriptors: {
      unicodeRange: "U+401-40c,U+40e-44f,U+451-45c,U+45e-45f,U+490-491",
    },
  },
];
